
<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col md="2">
            <Select
              v-model="filter.contactType"
              :items="contactTypes"
              label="Тип контакта:"
              class="fs-admin-complex-autocomplete"
              item-value="id"
              item-text="name"
              @change="getDataFromFirstPage"
              flat
              dense
              blank
            />
          </v-col>
          <v-col>
            <v-btn @click="createContact">Добавить</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Table
              :headers="headers"
              :items="contactsList"
              :items-per-page="contactsPerPage"
              :server-items-length="totalContacts"
              :page="page"
              :loading="loading"
              @update:request="updateRequest"
              class="elevation-1"
              disable-sort
            >
              <template v-slot:item.contact_type="{ item }">
                {{getContactTypeNameById(item.contact_type)}}
              </template>
              <template v-slot:item.options="{ item }">
                <v-btn icon x-small @click="updateContact(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon x-small @click="deleteContact(item)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </template>
            </Table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Modal
      v-if="modal.contact"
      :dialog.sync="modal.contact"
      :title="modal.new ? 'Добавить контакт' : 'Редактировать контакт'"
      :valid="valid"
      @handler="applyContactAction"
      contentClass="esh-theme adminModal"
      btnText="Сохранить"
      btnIcon="done_all"
      :width="420"
    >
      <template #body>
        <v-form v-model="valid">
          <v-card
            outlined
            class="infoBody"
          >
            <v-row no-gutters>
              <v-col>
                <Select
                  v-model="contact.contact_type"
                  :items="contactTypes"
                  label="Тип контакта:"
                  class="fs-admin-complex-autocomplete"
                  item-value="id"
                  item-text="name"
                  flat
                  :rules="[rules.required]"
                />
                <v-text-field
                  v-model="contact.contact"
                  label="Контакт:"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </template>
    </Modal>
    <ConfirmModal
      title="Внимание"
      :dialog.sync="modal.delete"
      :confirmBtnText="'Удалить'"
      contentClass="esh-theme adminModal"
      @confirm="confirmDeleteContact"
    >
      <template #body>
        <v-col>
          Вы действительно хотите удалить выбранный контакт?
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Table, Select, Modal, ConfirmModal } from '@/components/common'
import {
  GET_SUPPORT_CONTACTS,
  CREATE_SUPPORT_CONTACT,
  DELETE_SUPPORT_CONTACT,
  UPDATE_SUPPORT_CONTACT
} from '@/requests/superadmin'

class Contact {
  constructor(contact) {
    this.id = contact && contact.id
    this.contact_type = contact && contact.contact_type
    this.contact = contact && contact.contact
  }
}

export default {
  name: 'SupportContactsView',
  components: {
    Table,
    Select,
    Modal,
    ConfirmModal
  },
  data() {
    return {
      headers: [
        { text: 'Тип контакта', value: 'contact_type' },
        { text: 'Контакт', value: 'contact' },
        { value: 'options'}
      ],
      contactsList: [],
      page: 1,
      contactsPerPage: BASE.LIMIT,
      totalContacts: 0,
      loading: false,
      filter: {
        contactType: null
      },
      rules: {
        required: value => !!value || 'Заполните обязательно!'
      },
      modal: {
        new: false,
        edit: false,
        delete: false,
        contact: false
      },
      valid: false
    }
  },
  created() {
    this.getData()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (
        state.length > prevState.length &&
        state.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchContacts()
      } else if (
        state.length < prevState.length &&
        prevState.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchContacts()
      }
    }
  },
  computed: {
    ...mapState({
      contactTypes: state => state.common.constants.contact_types
    })
  },
  methods: {
    updateRequest({ page, itemsPerPage, offset }) {
      this.contactsPerPage = itemsPerPage
      this.page = page
      this.getData({ offset })
    },
    searchContacts: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    async getData(params = {}) {
      try {
        this.loading = true
        let {
          data: { results, count }
        } = await GET_SUPPORT_CONTACTS({
          limit: this.contactsPerPage,
          contact_type: this.filter.contactType,
          ...params
        })

        this.totalContacts = count
        this.contactsList = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить контакты техподдержки'
        })
      } finally {
        this.loading = false
      }
    },
    createContact() {
      this.modal.contact = true
      this.modal.new = true
      this.modal.edit = false
      this.contact = new Contact()
    },
    updateContact(contact) {
      this.modal.contact = true
      this.modal.edit = true
      this.modal.new = false
      this.contact = new Contact(contact)
    },
    async applyContactAction() {
      try {
        this.loading = true
        if (this.modal.new) {
          await CREATE_SUPPORT_CONTACT(this.contact)
        } else {
          UPDATE_SUPPORT_CONTACT(this.contact.id, {
            contact_type: this.contact.contact_type,
            contact: this.contact.contact
          })
        }
        this.$notify({
          type: 'success',
          text: this.modal.new
            ? 'Контакт успешно создан!'
            : 'Контакт успешно изменен'
        })
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: this.modal.new
            ? 'Не удалось создать новый контакт!'
            : 'Не удалось отредактировать контакт!'
        })
      } finally {
        this.getData()
        this.modal.contact = this.modal.new = this.modal.edit = false
      }
    },
    async confirmDeleteContact() {
      try {
        this.loading = true
        await DELETE_SUPPORT_CONTACT(this.contact.id)
        this.$notify({
          type: 'success',
          text: 'Контакт успешно удален!'
        })
      } catch {
        this.$notify({
          type: 'error',
          text: 'Неуспешное удаление контакта!'
        })
      } finally {
        this.loading = false
        this.getData()
        this.modal.delete = false
      }
    },
    deleteContact(contact) {
      this.contact = contact
      this.modal.delete = true
    },
    getContactTypeNameById(id) {
      const contactType = this.contactTypes.find(type => type.id === id)
      return contactType.name
    }
  }
}
</script>
